import { styled } from "@mui/material/styles";

interface Props {
  spacingColumns?: string;
  checkColumn?: boolean;
  isOnViewMode?: boolean;
}

export const ColumnWrapper = styled("div", {
  shouldForwardProp: (props) =>
    props !== "checkColumn" && props !== "spacingColumns" && props !== "isOnViewMode",
})(({ spacingColumns, checkColumn, isOnViewMode }: Props) => ({
  display: "grid",
  columnGap: "1rem",
  gridTemplateColumns: `${checkColumn ? "2rem" : ""} ${spacingColumns} ${
    isOnViewMode ? "" : "4rem"
  }`,
  alignItems: "center",
  padding: "6px 12px",
  background: "#EDF5FB",
  marginTop: 22,
  borderRadius: 8,
  marginBottom: 10,
}));

export const ColumnTitle = styled("span")(() => ({
  color: "#465869",
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "16px",
}));
